export const FacebookWhite = () => {
    return (
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21" cy="21" r="21" fill="white" fillOpacity="0.1" />
        <path
          d="M18.0422 29V21.4923H16V18.7892H18.0422V16.4804C18.0422 14.6661 19.2486 13 22.0282 13C23.1537 13 23.9859 13.1049 23.9859 13.1049L23.9203 15.6291C23.9203 15.6291 23.0716 15.6211 22.1454 15.6211C21.143 15.6211 20.9824 16.0701 20.9824 16.8154V18.7892H24L23.8687 21.4923H20.9824V29H18.0422Z"
          fill="white"
        />
      </svg>
    );
  };
  export const LinkedInWhite = () => {
    return (
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21" cy="21" r="21" fill="white" fillOpacity="0.1" />
        <path
          d="M16.4954 12.7776C16.4951 13.2491 16.3076 13.7011 15.9741 14.0343C15.6405 14.3676 15.1883 14.5546 14.7168 14.5544C14.2453 14.5541 13.7933 14.3666 13.46 14.0331C13.1268 13.6995 12.9398 13.2473 12.94 12.7758C12.9402 12.3043 13.1278 11.8523 13.4613 11.5191C13.7948 11.1859 14.2471 10.9988 14.7186 10.999C15.19 10.9993 15.6421 11.1868 15.9753 11.5203C16.3085 11.8539 16.4956 12.3061 16.4954 12.7776ZM16.5487 15.8708H12.9933V26.999H16.5487V15.8708ZM22.1662 15.8708H18.6286V26.999H22.1306V21.1593C22.1306 17.9062 26.3704 17.604 26.3704 21.1593V26.999H29.8813V19.9505C29.8813 14.4664 23.6061 14.6708 22.1306 17.364L22.1662 15.8708Z"
          fill="white"
        />
      </svg>
    );
  };
  export const InstagramWhite = () => {
    return (
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21" cy="21" r="21" fill="white" fillOpacity="0.1" />
        <path
          d="M17.64 13H24.36C26.92 13 29 15.08 29 17.64V24.36C29 25.5906 28.5111 26.7708 27.641 27.641C26.7708 28.5111 25.5906 29 24.36 29H17.64C15.08 29 13 26.92 13 24.36V17.64C13 16.4094 13.4889 15.2292 14.359 14.359C15.2292 13.4889 16.4094 13 17.64 13ZM17.48 14.6C16.7162 14.6 15.9836 14.9034 15.4435 15.4435C14.9034 15.9836 14.6 16.7162 14.6 17.48V24.52C14.6 26.112 15.888 27.4 17.48 27.4H24.52C25.2838 27.4 26.0164 27.0966 26.5565 26.5565C27.0966 26.0164 27.4 25.2838 27.4 24.52V17.48C27.4 15.888 26.112 14.6 24.52 14.6H17.48ZM25.2 15.8C25.4652 15.8 25.7196 15.9054 25.9071 16.0929C26.0946 16.2804 26.2 16.5348 26.2 16.8C26.2 17.0652 26.0946 17.3196 25.9071 17.5071C25.7196 17.6946 25.4652 17.8 25.2 17.8C24.9348 17.8 24.6804 17.6946 24.4929 17.5071C24.3054 17.3196 24.2 17.0652 24.2 16.8C24.2 16.5348 24.3054 16.2804 24.4929 16.0929C24.6804 15.9054 24.9348 15.8 25.2 15.8ZM21 17C22.0609 17 23.0783 17.4214 23.8284 18.1716C24.5786 18.9217 25 19.9391 25 21C25 22.0609 24.5786 23.0783 23.8284 23.8284C23.0783 24.5786 22.0609 25 21 25C19.9391 25 18.9217 24.5786 18.1716 23.8284C17.4214 23.0783 17 22.0609 17 21C17 19.9391 17.4214 18.9217 18.1716 18.1716C18.9217 17.4214 19.9391 17 21 17ZM21 18.6C20.3635 18.6 19.753 18.8529 19.3029 19.3029C18.8529 19.753 18.6 20.3635 18.6 21C18.6 21.6365 18.8529 22.247 19.3029 22.6971C19.753 23.1471 20.3635 23.4 21 23.4C21.6365 23.4 22.247 23.1471 22.6971 22.6971C23.1471 22.247 23.4 21.6365 23.4 21C23.4 20.3635 23.1471 19.753 22.6971 19.3029C22.247 18.8529 21.6365 18.6 21 18.6Z"
          fill="white"
        />
      </svg>
    );
  };
  export const YouTubeWhite = () => {
    return (
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21" cy="21" r="21" fill="white" fillOpacity="0.1" />
        <path
          d="M18.8571 23.5714L23.3057 21L18.8571 18.4286V23.5714ZM28.7657 16.86C28.8771 17.2629 28.9543 17.8029 29.0057 18.4886C29.0657 19.1743 29.0914 19.7657 29.0914 20.28L29.1429 21C29.1429 22.8771 29.0057 24.2571 28.7657 25.14C28.5514 25.9114 28.0543 26.4086 27.2829 26.6229C26.88 26.7343 26.1429 26.8114 25.0114 26.8629C23.8971 26.9229 22.8771 26.9486 21.9343 26.9486L20.5714 27C16.98 27 14.7429 26.8629 13.86 26.6229C13.0886 26.4086 12.5914 25.9114 12.3771 25.14C12.2657 24.7371 12.1886 24.1971 12.1371 23.5114C12.0771 22.8257 12.0514 22.2343 12.0514 21.72L12 21C12 19.1229 12.1371 17.7429 12.3771 16.86C12.5914 16.0886 13.0886 15.5914 13.86 15.3771C14.2629 15.2657 15 15.1886 16.1314 15.1371C17.2457 15.0771 18.2657 15.0514 19.2086 15.0514L20.5714 15C24.1629 15 26.4 15.1371 27.2829 15.3771C28.0543 15.5914 28.5514 16.0886 28.7657 16.86Z"
          fill="white"
        />
      </svg>
    );
  };
  
  export const IconButtonArrow = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
      >
        <rect opacity="0.1" width="30" height="30" rx="10" fill="white" />
        <path
          d="M17.5 14.8754L12.0322 19.7509L11.2667 19.0683L15.969 14.8754L11.2667 10.6826L12.0322 10L17.5 14.8754Z"
          fill="white"
        />
      </svg>
    );
  };
  export const SliderArrow = () => {
    return (
      <svg
        width="10"
        height="16"
        viewBox="0 0 10 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.0981979 7.73897L8.41183 15.1519L9.57574 14.1141L2.42601 7.73897L9.57574 1.36386L8.41183 0.32605L0.0981979 7.73897Z"
          fill="#5271FF"
        />
      </svg>
    );
  };

  export const HeadingVector = () => {
    return (
      <svg
        width="72"
        height="176"
        viewBox="0 0 72 176"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M69.7265 132.871C71.6464 128.932 72.4162 124.441 71.7823 119.874C70.9536 113.907 67.5529 108.67 62.9704 104.855C62.0331 104.075 61.0731 103.351 60.095 102.653C57.2876 99.3973 53.9521 96.5106 50.5338 93.8744C47.2386 91.3327 41.7197 87.9913 40.4989 83.7354C39.8745 81.5567 40.6293 79.3273 42.1621 77.945C44.3995 77.6435 46.6373 77.3524 48.8507 76.936C50.6701 76.9975 52.283 76.5373 53.6433 75.7246C54.8496 75.3286 56.045 74.8753 57.2151 74.2894C64.2066 70.7885 71.0532 63.3178 70.4691 54.3763C69.98 46.9106 65.5288 42.0587 59.4837 38.5142C52.5937 34.4724 44.8523 32.2725 37.6145 28.9619C35.3205 27.9126 33.4046 26.6325 33.151 23.8926C33.0374 22.6769 33.1601 21.5812 33.5355 20.6018C33.9389 20.5843 34.3424 20.5753 34.7454 20.597C39.543 20.7121 44.1305 16.3052 43.9123 11.4461C43.7415 7.62503 41.5282 4.42766 38.2407 3.03784C36.0183 0.532403 32.6434 -0.439149 28.9693 0.182237C25.6592 0.741547 22.3491 1.30146 19.039 1.86136C15.9186 2.38933 13.5278 5.207 12.6561 8.31753C11.8673 9.72424 11.1518 11.2002 10.5604 12.798C8.69031 17.8487 9.3487 23.0699 10.0642 28.0814C10.9725 34.4465 13.3018 40.3663 18.5001 44.8558C22.6566 48.4461 27.4528 50.6308 32.5429 52.2648C34.097 52.7639 35.546 53.2376 37.7132 54.784C31.7926 54.7076 27.0864 56.2395 22.3156 57.6815C19.9627 58.3925 18.0093 59.6003 15.9227 60.6857C11.3764 63.0489 6.23783 67.994 3.73828 72.4818C-4.47311 87.2287 1.7957 101.08 13.3013 109.607C20.3304 114.818 28.4503 116.793 36.7451 118.566C39.8378 119.228 43.0664 119.534 45.8983 121.226C46.688 121.698 47.2242 122.138 47.0901 123.055C47.0815 123.111 47.0634 123.15 47.0521 123.199C45.9535 123.67 44.649 123.981 43.4603 124.235C38.2058 124.61 32.9296 124.83 27.7222 125.547C17.1412 127.003 7.97438 132.371 4.57689 143.162C1.42846 153.162 4.27216 161.47 12.8698 168.009C13.5205 168.504 14.1653 169.023 14.8432 169.503C18.9321 170.66 22.9314 172.1 26.9198 173.579C28.77 173.822 30.6048 173.94 32.36 173.909C32.9233 174.25 33.4748 174.606 34.0698 174.909C44.5403 180.233 53.799 164.632 43.3236 159.106C41.3556 158.068 39.7925 156.789 40.2729 154.307C40.8218 151.474 40.0751 148.887 38.6175 146.872C38.7728 146.623 38.9666 146.425 39.1427 146.205C42.4315 146.151 45.7326 146.432 49.0014 146.045C53.7021 145.489 58.4875 144.307 62.3953 141.519C65.5786 139.247 68.0782 136.263 69.7265 132.871Z"
          fill="#FFA852"
        />
      </svg>
    );
  };

  export const VideosBtnArrow = () => {
    return (
      <svg
        width="30"
        height="30"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect opacity="0.1" width="30" height="30" rx="10" fill="#5271FF" />
        <path
          d="M17.5 14.8754L12.0322 19.7509L11.2667 19.0683L15.969 14.8754L11.2667 10.6826L12.0322 10L17.5 14.8754Z"
          fill="#5271FF"
        />
      </svg>
    );
  };

  export const ImageBgOrange = ({ className }) => {
    return (
      <svg
        className={`${className}`}
        width="586"
        height="549"
        viewBox="0 0 586 549"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M123.834 247.216C124.353 243.313 124.997 239.398 125.918 235.459C129.44 220.382 133.519 205.212 139.101 190.512C144.313 181.386 150.673 173.351 158.055 166.275C161.535 167.048 165.433 165.692 166.567 161.294C166.862 160.149 167.219 159.039 167.603 157.944C183.683 145.45 203.303 136.224 224.983 128.701C275.008 111.347 328.206 100.851 372.809 136.248C409.456 165.33 428.064 211.938 422.885 257.758C412.951 345.653 343.63 397.218 264.436 419.642C262.934 419.463 261.389 419.344 259.747 419.374C243.354 419.664 227.794 418.12 211.888 414.263C210.92 414.031 209.948 413.903 208.975 413.765C208.42 413.223 207.861 412.682 207.231 412.111C190.445 396.969 172.616 382.911 159.495 363.86C150.84 351.289 143.191 338.266 137.123 324.865C128.286 299.71 122.694 273.565 123.834 247.216ZM444.152 122.768C444.574 122.756 444.979 122.703 445.37 122.615C448.011 123.602 450.686 124.116 453.337 124.252C463.193 130.127 470.571 138.636 476.781 148.269C466.743 138.853 455.789 130.407 444.152 122.768ZM459.179 152.213C470.628 162.01 480.905 173.059 489.691 185.569C504.468 267.199 477.12 353.643 409.367 407.406C405.639 410.364 401.78 413.182 397.855 415.923C434.573 385.171 462.629 344.789 476.004 294.111C489.103 244.468 481.465 194.013 459.179 152.213ZM585.102 256.73C585.175 248.066 585.244 239.403 585.322 230.759C586.206 215.565 581.219 201.413 575.807 187.73C563.554 156.758 552.99 124.837 530.048 99.1535C485.393 49.1645 428.399 19.2523 363.557 5.4414C331.018 -1.48912 295.553 -2.0669 263.493 5.25716C221.295 14.8942 181.813 34.644 143.982 56.4497C96.8323 83.6299 56.7093 119.339 31.4879 166.359C9.48665 207.375 -3.03233 253.142 0.63252 301.177C0.677509 304.229 0.722478 307.284 0.764006 310.334C-2.81087 393.89 41.811 450.677 109.311 491.701C160.893 523.051 217.952 543.341 279.019 547.961C328.249 551.685 376.334 545.658 422.454 525.706C474.767 503.074 514.586 465.797 546.187 421.036C567.543 390.784 586.24 357.143 585.576 317.601C585.714 299.706 585.856 281.813 586 263.913C585.704 261.513 585.405 259.12 585.102 256.73Z"
          fill="#FFA852"
        />
      </svg>
    );
  };
  export const Like = () => {
    return (
      <svg
        width="24"
        height="20"
        viewBox="0 0 24 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.2194 0C15.0244 0 13.1027 0.925218 11.9048 2.48913C10.7068 0.925218 8.78508 0 6.59014 0C4.84293 0.00193039 3.16785 0.683141 1.93238 1.89418C0.696918 3.10522 0.00196932 4.74719 0 6.45986C0 13.7532 11.0321 19.6567 11.5019 19.9005C11.6257 19.9658 11.7642 20 11.9048 20C12.0454 20 12.1838 19.9658 12.3076 19.9005C12.7774 19.6567 23.8095 13.7532 23.8095 6.45986C23.8076 4.74719 23.1126 3.10522 21.8771 1.89418C20.6417 0.683141 18.9666 0.00193039 17.2194 0ZM11.9048 18.2126C9.96386 17.104 1.70068 12.0539 1.70068 6.45986C1.70237 5.18924 2.21805 3.97113 3.13463 3.07266C4.05122 2.1742 5.29389 1.66871 6.59014 1.66706C8.65753 1.66706 10.3933 2.74648 11.1182 4.48022C11.1823 4.6331 11.2912 4.76386 11.4313 4.85588C11.5714 4.94791 11.7362 4.99704 11.9048 4.99704C12.0734 4.99704 12.2382 4.94791 12.3782 4.85588C12.5183 4.76386 12.6273 4.6331 12.6913 4.48022C13.4162 2.74336 15.152 1.66706 17.2194 1.66706C18.5156 1.66871 19.7583 2.1742 20.6749 3.07266C21.5915 3.97113 22.1072 5.18924 22.1088 6.45986C22.1088 12.0455 13.8435 17.103 11.9048 18.2126Z"
          fill="black"
        />
      </svg>
    );
  };
  export const Comments = () => {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.0002 21C5.47721 20.9999 0.999961 16.5227 1 10.9997C1 8.34748 2.05358 5.80391 3.92897 3.92852C7.83487 0.0233192 14.167 0.0239051 18.0722 3.92981C21.4776 7.33586 21.9715 12.6854 19.2473 16.6574C19.3734 17.1777 20.0987 18.6487 20.7663 19.8232C20.955 20.1551 20.8389 20.5771 20.507 20.7657C20.2989 20.884 20.0443 20.8862 19.8342 20.7715C19.8272 20.7676 19.1275 20.3864 18.3408 20.0087C17.2382 19.4794 16.7615 19.3372 16.581 19.299C14.9328 20.4116 12.9887 21.0041 11.0002 21ZM11.0002 2.38196C6.24832 2.38196 2.38241 6.24787 2.38241 10.9997C2.38241 15.7516 6.24832 19.6175 11.0002 19.6175C12.767 19.6213 14.4919 19.0785 15.9381 18.0635C16.3252 17.7923 16.8426 17.9127 17.3441 18.0832C17.6687 18.1938 18.0742 18.3605 18.5512 18.58C18.3288 18.1204 18.1585 17.73 18.0442 17.4178C17.8328 16.8412 17.7457 16.3821 18.0074 16.0174C19.0588 14.5559 19.6224 12.8001 19.618 10.9998C19.618 6.24787 15.7521 2.38196 11.0002 2.38196Z"
          fill="black"
          stroke="black"
          stroke-width="0.3"
        />
      </svg>
    );
  };
  export const Share = () => {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.8284 1.17165C20.6627 1.00587 20.414 0.95489 20.1965 1.04192L1.36834 8.5731C1.15291 8.65928 1.00865 8.86443 1.00037 9.09635C0.99213 9.32822 1.1215 9.54311 1.33026 9.64436L8.7548 13.2452L12.3557 20.6697C12.4539 20.8722 12.6589 21 12.8827 21C12.8897 21 12.8967 20.9999 12.9037 20.9996C13.1355 20.9914 13.3407 20.8471 13.4269 20.6317L20.9581 1.8036C21.0452 1.58595 20.9942 1.33739 20.8284 1.17165ZM3.03491 9.16865L17.9813 3.19017L9.07386 12.0975L3.03491 9.16865ZM12.8314 18.9651L9.90249 12.9261L18.8099 4.01876L12.8314 18.9651Z"
          fill="black"
          stroke="black"
          stroke-width="0.3"
        />
      </svg>
    );
  };
  export const ShavedVideo = () => {
    return (
      <svg
        width="17"
        height="22"
        viewBox="0 0 17 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1563 1H2.8437C1.84672 1 1 1.80303 1 2.84128V19.547C1.00293 20.8648 2.61463 21.4831 3.5309 20.558L7.84295 16.2529C8.18851 15.8928 8.81149 15.8928 9.15705 16.2529L13.4691 20.558C14.3858 21.4834 15.9973 20.8642 16 19.547V2.84128C16 1.80303 15.1533 1 14.1563 1ZM14.8265 19.547C14.825 19.826 14.4778 19.9181 14.2981 19.7286C13.4361 18.8664 10.9778 16.412 9.98762 15.425C9.20868 14.6114 7.79249 14.6112 7.01391 15.4234C6.32991 16.1052 4.99102 17.442 3.93557 18.4957L2.70769 19.7215C2.53076 19.9089 2.17914 19.8464 2.17347 19.5576V2.84128C2.17347 2.46696 2.47729 2.17197 2.8437 2.17197H14.1563C14.5221 2.17197 14.8265 2.46649 14.8265 2.84128V19.547Z"
          fill="black"
          stroke="black"
          stroke-width="0.3"
        />
      </svg>
    );
  };
  export const OptionIcon = () => {
    return (
      <svg
        width="3"
        height="15"
        viewBox="0 0 3 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="1.5" cy="1.5" r="1.5" fill="black" />
        <circle cx="1.5" cy="7.5" r="1.5" fill="black" />
        <circle cx="1.5" cy="13.5" r="1.5" fill="black" />
      </svg>
    );
  };
  export const Star = () => {
    return (
      <svg
        width="16"
        height="15"
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.49542 4.89328L1.24209 5.50995L1.16675 5.52528C1.05271 5.55556 0.948751 5.61555 0.865483 5.69915C0.782214 5.78274 0.722624 5.88694 0.692796 6.0011C0.662969 6.11526 0.663973 6.23529 0.695706 6.34893C0.72744 6.46257 0.788766 6.56576 0.873421 6.64795L3.95475 9.64728L3.22809 13.8839L3.21942 13.9573C3.21244 14.0752 3.23693 14.1929 3.29039 14.2983C3.34384 14.4037 3.42434 14.4929 3.52364 14.557C3.62295 14.621 3.73748 14.6575 3.85552 14.6627C3.97356 14.6679 4.09086 14.6416 4.19542 14.5866L7.99942 12.5866L11.7948 14.5866L11.8614 14.6173C11.9715 14.6606 12.0911 14.6739 12.2079 14.6558C12.3248 14.6377 12.4347 14.5888 12.5265 14.5141C12.6182 14.4395 12.6885 14.3418 12.73 14.231C12.7715 14.1203 12.7828 14.0005 12.7628 13.8839L12.0354 9.64728L15.1181 6.64728L15.1701 6.59062C15.2444 6.49913 15.2931 6.38958 15.3112 6.27315C15.3294 6.15671 15.3164 6.03753 15.2735 5.92777C15.2306 5.818 15.1594 5.72157 15.0671 5.64829C14.9748 5.57501 14.8647 5.52751 14.7481 5.51062L10.4948 4.89328L8.59342 1.03995C8.5384 0.928305 8.45323 0.834292 8.34755 0.768551C8.24186 0.702811 8.11988 0.667969 7.99542 0.667969C7.87096 0.667969 7.74898 0.702811 7.64329 0.768551C7.53761 0.834292 7.45244 0.928305 7.39742 1.03995L5.49542 4.89328Z"
          fill="#FDB11A"
        />
      </svg>
    );
  };


  export const SecondryHeadingVector = () => {
    return (
      <svg
        className="scale-down-mobile"
        width="149"
        height="61"
        viewBox="0 0 149 61"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.3"
          d="M112.487 1.9262C109.153 0.29958 105.351 -0.352619 101.484 0.184475C96.4329 0.886528 91.9992 3.76767 88.7697 7.65008C88.1088 8.44421 87.4958 9.25751 86.9053 10.0862C84.1488 12.4647 81.705 15.2906 79.4732 18.1866C77.3214 20.9784 74.4926 25.6541 70.8897 26.6884C69.0451 27.2175 67.1577 26.5779 65.9875 25.2793C65.7322 23.3838 65.4858 21.4878 65.1334 19.6126C65.1854 18.0712 64.7958 16.7047 64.1078 15.5522C63.7725 14.5302 63.3887 13.5174 62.8927 12.5261C59.9289 6.60273 53.6043 0.802139 46.0345 1.29703C39.7141 1.71136 35.6065 5.48251 32.6058 10.6041C29.184 16.4415 27.3216 23.0001 24.5189 29.1322C23.6306 31.0757 22.5468 32.6989 20.2272 32.9137C19.1981 33.01 18.2704 32.906 17.4413 32.588C17.4265 32.2462 17.4189 31.9044 17.4372 31.5629C17.5347 27.4983 13.8038 23.6117 9.69021 23.7966C6.45528 23.9412 3.74841 25.8164 2.57181 28.6016C0.450727 30.4845 -0.37178 33.3438 0.15428 36.4566C0.627787 39.261 1.10181 42.0654 1.57581 44.8697C2.02279 47.5134 4.4082 49.539 7.04155 50.2775C8.23245 50.9458 9.48203 51.5519 10.8347 52.053C15.1105 53.6374 19.5308 53.0796 23.7734 52.4734C29.1621 51.7038 34.1737 49.7304 37.9745 45.3263C41.014 41.8049 42.8635 37.7414 44.2469 33.4289C44.6694 32.1123 45.0705 30.8846 46.3796 29.0486C46.315 34.0646 47.6119 38.0518 48.8326 42.0938C49.4346 44.0871 50.4571 45.7421 51.3759 47.5099C53.3766 51.3616 57.5631 55.7152 61.3624 57.8328C73.847 64.7897 85.5736 59.4786 92.7925 49.7308C97.2036 43.7756 98.8756 36.8962 100.377 29.8688C100.937 27.2485 101.197 24.5132 102.629 22.1139C103.028 21.4449 103.401 20.9906 104.178 21.1042C104.224 21.1115 104.258 21.1269 104.299 21.1364C104.698 22.0671 104.961 23.1724 105.176 24.1795C105.494 28.6312 105.68 33.1013 106.287 37.5131C107.52 46.4776 112.064 54.2439 121.2 57.1224C129.666 59.7898 136.699 57.3805 142.235 50.0964C142.654 49.5451 143.093 48.9988 143.499 48.4245C144.479 44.9603 145.699 41.572 146.95 38.1929C147.156 36.6254 147.256 35.0709 147.23 33.5839C147.519 33.1067 147.82 32.6394 148.076 32.1353C152.584 23.2645 139.376 15.4203 134.697 24.2953C133.819 25.9626 132.736 27.2869 130.635 26.8799C128.237 26.4149 126.046 27.0475 124.341 28.2824C124.13 28.1508 123.962 27.9867 123.776 27.8374C123.73 25.0511 123.968 22.2544 123.64 19.4849C123.169 15.5024 122.169 11.4481 119.808 8.13728C117.885 5.44032 115.359 3.32264 112.487 1.9262Z"
          fill="#FFA852"
        />
      </svg>
    );
  };
  